import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import HeroSection from "../components/HeroSection/HeroSection";
import Service from "../components/Service/Service";
import FAQ from "../components/FAQ/FAQ";
import Footer from "../components/Footer/Footer";
import FixedButton from "../components/FixedButton/FixedButton";
import * as apis from "../apis";

export default function HomeContainer() {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apis.getLandingPageInfo();
        setData(res?.data?.value);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <HeroSection data={data} id="home" />
      <Service data={data} id="service" />
      <FAQ id="faq" />
      <Footer data={data} />
      <FixedButton />
    </>
  );
}
